// 申請画面(競合店売価・鮮度起因・本部指示)の申請・編集時、後続システムの桁数制限のため、非会員価格がこの金額以上の売価は申請不可
export const REQUEST_SELLING_PRICE_LIMIT = 1000000;
